import React from 'react'

import { DropButton } from '@/components'
import { t } from '@/i18n'
import { IMenu } from '@/types'
import {
  addCarPath,
  addCustomerPath,
  addProposalPath,
  addReportPath
} from '@/utils/index'

const menus: IMenu[] = [
  {
    id: 'menu-cars',
    name: 'cars',
    icon: 'icon-car',
    path: addCarPath,
  },
  {
    id: 'menu-proposals',
    name: 'proposals',
    icon: 'icon-briefcase',
    path: addProposalPath,
  },
  {
    id: 'menu-customers',
    name: 'customers',
    icon: 'icon-customer',
    path: addCustomerPath,
  },
  {
    id: 'menu-reports',
    name: 'reports',
    icon: 'icon-file',
    path: addReportPath,
  },
]

const HeaderMenu: React.FC = () => {
  return (
    <div className="btn-box">
      <DropButton
        menus={menus}
        buttonText={t('add')}
        buttonClassName="main-btn"
        leftIcon={<span className="icon-plus" />}
      />
    </div>
  )
}

export default HeaderMenu
